module.exports = __webpack_public_path__ + "static/media/ENRIQUEZ.e6193d89.png";